// Display-only helpers to render stored 24h "HH:MM" session times in 12-hour AM/PM format.
export function to12h(hhmm) {
  if (!hhmm) return '';
  const [hh, mm] = String(hhmm).split(':');
  const h = parseInt(hh, 10);
  const m = parseInt(mm, 10);
  if (isNaN(h)) return String(hhmm);
  const mer = h < 12 ? 'AM' : 'PM';
  const h12 = (h % 12) || 12;
  return `${h12}:${String(isNaN(m) ? 0 : m).padStart(2, '0')} ${mer}`;
}

export function range12(start, end) {
  if (!start) return '';
  return end ? `${to12h(start)}–${to12h(end)}` : to12h(start);
}
